import React from 'react';
import cn from 'classnames';

import styles from './ItemCardTop.module.scss';
import { Image } from '@components/Image/Image';

const Card = ({ children, className = '', ...props }) => {
  return (
    <div className={`card ${className}`} {...props}>
      {children}
    </div>
  );
};

Card.Image = ({ image, alt = '', classNameContainer = null, classNameImage = null, ...props }) => (
  <div className={cn(classNameContainer)}>
    <Image image={image} alt={alt} className={cn(classNameImage)} {...props} />
  </div>
);

Card.Title = ({ children, className = null, ...props }) => (
  <h4 className={cn(className)} {...props}>
    {children}
  </h4>
);

Card.Subtitle = ({ children, className = null, ...props }) => (
  <h6 className={cn(className)} {...props}>
    {children}
  </h6>
);

Card.Content = ({ children, className = null, ...props }) => (
  <div className={cn(className)} {...props}>
    {children}
  </div>
);

export const ItemCardTop = ({ image, imgAltText, title, subtitle }) => (
  <Card className={cn(styles.card)}>
    <Card.Image image={image} alt={imgAltText} classNameContainer={styles.cardImgContainer} />
    <Card.Content>
      <Card.Title className={cn(styles.cardTitle)}>{title}</Card.Title>
      <Card.Subtitle className={cn(styles.cardSubtitle)}>{subtitle}</Card.Subtitle>
    </Card.Content>
  </Card>
);